import types from './types';

const defaultState = {
  defaultFilteredList: { result: [], totalPages: '0', totalElements: '0', entityType: '' },
  dataViewList: [],
  latestDataViewId: null,
  createdDataView: {},
  sharedDataView: {},
  shareUrl: '',
  isLoading: false,
  isLoadingDataView: false,
  isLoadingDataViewList: false,
  isLoadingGetShareUrl: false,
  isLoadingDataViewError: false
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.GET_DEFAULT_DATAVIEW:
      return {
        ...state,
        latestDataViewId: params.latestDataViewId,
        shareUrl: '',
        isLoadingDataView: true,
        isLoadingDataViewError: false
      };
    case types.GET_DEFAULT_DATAVIEW_SUCCESS:
      return {
        ...state,
        defaultFilteredList: data,
        createdDataView: {},
        isLoadingDataView: false,
        isLoadingDataViewError: false
      };
    case types.GET_DEFAULT_DATAVIEW_FAILURE:
      return { ...state, isLoadingDataView: false , isLoadingDataViewError: true};

    case types.GET_DATAVIEW_LIST:
      return { ...state, isLoading: true };
    case types.GET_DATAVIEW_LIST_SUCCESS:
      return { ...state, dataViewList: data, isLoading: false };
    case types.GET_DATAVIEW_LIST_FAILURE:
      return { ...state, isLoading: false };

    case types.GET_FAVORITE_DATAVIEW_LIST:
      return { ...state, isLoading: true };
    case types.GET_FAVORITE_DATAVIEW_LIST_SUCCESS:
      return { ...state, favoriteDataViewList: data, isLoading: false };
    case types.GET_FAVORITE_DATAVIEW_LIST_FAILURE:
      return { ...state, isLoading: false };

    case types.CREATE_NEW_DATAVIEW:
      return { ...state, isLoadingDataViewList: true };
    case types.CREATE_NEW_DATAVIEW_SUCCESS:
      return { ...state, createdDataView: data, shareUrl: '', isLoadingDataViewList: false };
    case types.CREATE_NEW_DATAVIEW_FAILURE:
      return { ...state, isLoadingDataViewList: false };

    case types.DELETE_DATAVIEW:
      return { ...state, isLoading: true };
    case types.DELETE_DATAVIEW_SUCCESS:
      return { ...state, createdDataView: data, shareUrl: '', isLoading: false };
    case types.DELETE_DATAVIEW_FAILURE:
      return { ...state, isLoading: false };

    case types.LOCK_DATAVIEW:
    case types.FAVORITE_DATAVIEW:
      return { ...state, isLoading: true };
    case types.LOCK_DATAVIEW_SUCCESS:
    case types.LOCK_DATAVIEW_FAILURE:
    case types.FAVORITE_DATAVIEW_FAILURE:
    case types.FAVORITE_DATAVIEW_SUCCESS:
      return { ...state, isLoading: false };

    case types.GET_SHARE_URL_DATAVIEW:
      return { ...state, shareUrl: '', isLoadingGetShareUrl: true };
    case types.GET_SHARE_URL_DATAVIEW_SUCCESS:
      return { ...state, shareUrl: data, isLoadingGetShareUrl: false };
    case types.GET_SHARE_URL_DATAVIEW_FAILURE:
      return { ...state, isLoadingGetShareUrl: false };

    case types.SHARE_DATAVIEW:
      return { ...state, sharedDataView: {}, isLoading: true };
    case types.SHARE_DATAVIEW_SUCCESS:
      return {
        ...state,
        createdDataView: data,
        sharedDataView: data,
        isLoading: false
      };
    case types.SHARE_DATAVIEW_FAILURE:
      return { ...state, isLoading: false };

    case types.CLEAR_DEFAULT_FILTERED_LIST:
      return { ...state, defaultFilteredList: defaultState.defaultFilteredList };

    case types.CLEAR_SHARED_DATA_VIEW:
      return { ...state, sharedDataView: {} };

    default:
      return state;
  }
};
